import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconUserComponent } from "./med-icon-user.component";

@NgModule({
  declarations: [
    MedIconUserComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconUserComponent,
  ],
})
export class MedIconUserModule { }
